<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-font`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.264 21c2.406 0 4.194.677 5.353 2.042 1.005 1.193 1.512 2.914 1.512 5.133V38.81a1 1 0 01-1 1H43.69a1 1 0 01-1-1v-1.132a6.988 6.988 0 01-2.04 1.73c-1.112.584-2.387.886-3.806.886-1.601 0-2.892-.435-3.846-1.291l-.186-.177c-1.064-.971-1.593-2.242-1.593-3.804 0-2.084.749-3.708 2.223-4.817 1.318-1.05 3.195-1.595 5.63-1.666l3.4-.099v-.508c0-2.363-1.116-3.512-3.426-3.512-.994 0-1.794.2-2.38.592a2.79 2.79 0 00-1.1 1.354l-.042.124a1 1 0 01-1.05.7l-1.677-.16a1 1 0 01-.9-1.091l.01-.082.033-.133.014-.048c.448-1.506 1.266-2.666 2.428-3.432 1.19-.84 2.82-1.245 4.88-1.245zM17.8 9a.93.93 0 01.867.594l11.27 29.142A.93.93 0 0129.072 40h-2.246a.93.93 0 01-.867-.594l-3.767-9.74H9.845L6.042 39.41a.93.93 0 01-.866.591H2.928a.93.93 0 01-.865-1.267L13.439 9.59a.93.93 0 01.866-.59H17.8zm24.673 23.36v-.809l-3.175.098c-2.896.066-4.3 1.154-4.3 3.235 0 .626.222 1.112.702 1.522.463.42 1.103.641 1.889.641 1.333 0 2.469-.455 3.435-1.365.959-.902 1.449-2.02 1.449-3.323zM16.048 13.777l-4.736 12.13h9.427l-4.691-12.13z"/></svg>
</template>
<script>

export default {
  name: 'IconFont',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
